'use strict';

var GetIntrinsic = require('get-intrinsic');

var $test = GetIntrinsic('RegExp.prototype.test');

var callBind = require('call-bind');

module.exports = function regexTester(regex) {
	return callBind($test, regex);
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/es-abstract/helpers/regexTester.js
 ** module id = 2901
 ** module chunks = 0
 **/